import Axios from "../config/Axios";

export const ApiCreatePresignedUrl = async (key) => {
  try {
    const res = await Axios.post("/POSTcreatePresignedUrl", {
      key,
    });

    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const ApiDeleteFile = async (key) => {
  try {
    const res = await Axios.post(
      `/POSTdeleteFile`,
      { key },
      {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      }
    );
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const ApiDescargaFile = async (data) => {
  try {
    const result = await Axios.post(`/downloadStorageFile`, {
      key: data,
    });
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
